import { render } from "./DiscountComponent.vue?vue&type=template&id=b25ebf98"
import script from "./DiscountComponent.vue?vue&type=script&lang=js"
export * from "./DiscountComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__